export default __webpack_public_path__ + "static/media/mic-on.d4ddd205.svg";